import ServiceApi from "../ServiceApi";
class MinigamesServiceApi extends ServiceApi {
  constructor() {
    super("minigamesService", "miniGames");
  }
  getActivities() {
    return this.request("getActivities");
  }

  /**
   *
   * @param [name: String]
   * @param [activityType: String]
   */
  getActivities_v2() {
    return this.request("getActivities_v2");
  }

  /**
   *
   * @param [activity_type]
   */
  getActivity_v2ByName(activity_type) {
    let params = {
      activityType: activity_type,
    };

    return this.request("getActivities_v2", params);
  }

  /**
   *
   * @param [activity_type]
   */
  getActivityByName(activity_type) {
    let params = {
      activityType: activity_type,
    };

    return this.request("getActivities", params);
  }

  /**
   *
   * @param [activity_key: String]
   */
  getActivityByKey(activity_key) {
    let params = {
      activityKey: activity_key,
    };

    return this.request("getActivityByKey", params);
  }

  /**
   *
   * @param {object} params
   * @param {number} params.profileId
   * @param {string} params.activityKey
   */
  getActivityByKeyForProfile(params) {
    return this.request("getActivityByKeyForProfile", params);
  }

  /**
   *
   * @param [offers: string] uuid
   * @param [tags: string] tag
   */

  getActivitiesForOffers(offers, tags) {
    let params = {};

    if (offers && offers.length) {
      params.offersUuid = offers;
    }
    if (tags) {
      params.offerTags = tags;
    }
    return this.request("getActivitiesForOffers", params);
  }
  /**
   *
   * @param landingName: string
   */

  reachGoalWithConditionsLandingCondition(landingName) {
    let params = {
      landingName: landingName,
    };

    return this.request("reachGoalWithConditionsLandingCondition", params);
  }

  /**
   *
   * @param
   * landingName: string
   * conditionName: string
   */

  isGoalWithConditionsLandingConditionReached(landingName, conditionName) {
    let params = {
      landingName: landingName,
      conditionName: conditionName,
    };

    return this.request("isGoalWithConditionsLandingConditionReached", params);
  }

  reachConditionAndSendRewards(conditionName, activityKey) {
    let params = {
      condition: conditionName,
      activityKey: activityKey,
    };

    return this.request("reachConditionAndSendRewards", params);
  }

  /**
   * Special method for cb season X promo Highlanders
   * @param
   * condition: array
   * activityKey: string
   */

  reachConditionsAndSendRewards(conditionName, activityKey) {
    let params = {
      conditions: conditionName,
      activityKey: activityKey,
    };

    return this.request("reachConditionsAndSendRewards", params);
  }

  isConditionReached(conditionName, activityKey) {
    let params = {
      activityKey: activityKey,
      conditionName: conditionName,
    };

    return this.request("isConditionReached", params);
  }
}
export default new MinigamesServiceApi();
